module.exports = __webpack_public_path__ + "08825d857fe4f4e08d8f2549c4932f.svg";